import React from 'react';
import './ExpansionSelector.css';  // Asegúrate de crear y usar este archivo CSS para estilos

const ExpansionSelector = ({ expansions, onToggle, selectedExpansions }) => {
    return (
        <div className="expansion-selector">
            <h3>Selecciona qué expansiones quieres añadir</h3>
            <div className="expansion-list">
                {expansions.map((expansion) => {
                    const isSelected = selectedExpansions.includes(expansion.name);
                    return (
                        <div 
                            key={expansion.name} 
                            className={`expansion-item ${isSelected ? 'selected' : ''}`}
                            onClick={() => onToggle(expansion.name, !isSelected)}
                        >
                            <img 
                                src={expansion.image} 
                                alt={expansion.name} 
                                className="expansion-image"
                            />
                            <span className="expansion-text">{expansion.name}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ExpansionSelector;
